import React, { useMemo } from 'react';
import { getIn } from 'formik';
import './radio-button.scss';

export function RadioButton({ label, automationId, field, light, small = false, ...rest }) {
  const { form, ...inputProps } = rest;

  const disabled = useMemo(
    () =>
      rest.disabled ||
      getIn(form?.initialStatus?.initialDisabled || {}, field.name) ||
      form?.initialStatus?.initialDisabled?.[field.name],
    [rest.disabled, form?.initialStatus?.initialDisabled, field.name],
  );

  return (
    <div className={`RadioButton ${light ? 'light' : ''} ${small ? 'small' : ''}`}>
      <label
        className={`centered label-style ${field.checked ? 'selected' : ''} ${
          disabled ? 'disabled' : ''
        }`}
      >
        <input
          {...field}
          {...inputProps}
          className="input-style"
          automationid={automationId}
          disabled={disabled}
        />
        {label}
      </label>
    </div>
  );
}
